import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Card } from 'components/Card'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import { AreaTypeDetails } from 'components/AreaTypeDetails'
import { Project } from 'models/project'
import { isNil, isEmpty } from 'ramda'
import styles from './ProjectCard.module.scss'

type ProjectCardProps = {
  project: Project
}

export const ProjectCard: FC<ProjectCardProps> = (props) => {
  const { t } = useTranslation()

  return (
    <div className={styles.projectCard}>
      <Card className={styles.card}>
        <Stack space="medium">
          <div className={styles.header}>
            <Heading size="card" truncate>
              {props.project.name}
            </Heading>
            <Text truncate>
              {[
                props.project.city,
                props.project.municipality,
                props.project.state,
                props.project.country,
              ]
                .filter((region) => !isEmpty(region) && !isNil(region) && region !== '-')
                .join(', ')}
            </Text>
          </div>
          <div className={styles.isochrone}>
            <AreaTypeDetails project={props.project} />
          </div>
          <img className={styles.mapPreview} src={props.project.imageUrl} width="300px" height="300px" alt="" />
          <Link to={`/projects/${props.project.id}`} className={styles.cta}>
            <Button full>{t('project.card.cta')}</Button>
          </Link>
        </Stack>
      </Card>
    </div>
  )
}

ProjectCard.displayName = 'ProjectCard'
